var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCrossRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-cross-red"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-cross-red",
    clipPath: "url(#clip-icon-cross-red)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_627",
    "data-name": "Group 627",
    transform: "translate(-111.001 -123)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_105",
    "data-name": "Ellipse 105",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(111.001 123)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_105_-_Outline",
    "data-name": "Ellipse 105 - Outline",
    d: "M10,1a9,9,0,1,0,9,9,9.01,9.01,0,0,0-9-9m0-1A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z",
    transform: "translate(111.001 123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-times",
    "data-name": "Icon awesome-times",
    d: "M6.627,10.43,9.359,7.7a.859.859,0,0,0,0-1.214l-.607-.607a.859.859,0,0,0-1.214,0L4.805,8.609,2.073,5.876a.859.859,0,0,0-1.214,0l-.607.607a.859.859,0,0,0,0,1.214L2.984,10.43.251,13.162a.859.859,0,0,0,0,1.214l.607.607a.859.859,0,0,0,1.214,0l2.732-2.732,2.732,2.732a.859.859,0,0,0,1.214,0l.607-.607a.859.859,0,0,0,0-1.214Z",
    transform: "translate(116.196 122.57)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrossRed);
export default __webpack_public_path__ + "static/media/icon-cross-red.214217764884bfd13b420f0e5356aae9.svg";
export { ForwardRef as ReactComponent };